/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Unit_Rm_CostInputs */

const en_field_unit_rm_cost = /** @type {(inputs: Field_Unit_Rm_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unit cost`)
};

/**
* | output |
* | --- |
* | "Unit cost" |
*
* @param {Field_Unit_Rm_CostInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_unit_rm_cost = /** @type {((inputs?: Field_Unit_Rm_CostInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Unit_Rm_CostInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_unit_rm_cost(inputs)
});